module.exports = __webpack_public_path__ + "img/ability-lab.593ea9f1.svg";